import type { PushInput } from '@/shared/lib/notifications/notification';


export const ENTERPRISE_PENDING_NOTIFICATION_ID = 'enterprise-pending';

export const ENTERPRISE_PENDING_NOTIFICATION: PushInput = {
    id      : ENTERPRISE_PENDING_NOTIFICATION_ID,
    severity: 'info',
    category: 'account_update',
    title   : 'Enterprise request received',
    text    : 'Your enterprise plan request has been received. Our manager will contact you to agree on the terms.',
};
